"use client";

import { Play } from "lucide-react";
import Image from "next/image";
import { useRef, useState } from "react";
import {
  VIDEO_EMBED_URL,
  VIDEO_THUMBNAIL_FALLBACK,
  VIDEO_THUMBNAIL_PRIMARY,
} from "@/config/constants";

export function VideoFacade() {
  const [playing, setPlaying] = useState(false);
  const [thumbnail, setThumbnail] = useState(VIDEO_THUMBNAIL_PRIMARY);
  const [thumbnailFailed, setThumbnailFailed] = useState(false);
  const frameRef = useRef<HTMLDivElement>(null);

  const handlePlay = () => {
    setPlaying(true);
    window.requestAnimationFrame(() => frameRef.current?.focus());
  };

  if (playing) {
    return (
      <div
        ref={frameRef}
        tabIndex={-1}
        className="relative aspect-video w-full bg-ink-900 focus:outline-none"
      >
        <iframe
          src={VIDEO_EMBED_URL}
          title="Video: Jak funguje správa firemního profilu na Firmy.cz"
          className="absolute inset-0 h-full w-full"
          allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={handlePlay}
      aria-label="Přehrát video o správě profilu na Firmy.cz"
      className="group relative block aspect-video w-full bg-ink-900"
    >
      {!thumbnailFailed ? (
        <Image
          src={thumbnail}
          alt=""
          fill
          sizes="(min-width: 1024px) 60vw, 100vw"
          className="grayscale-photo object-cover"
          onError={() => {
            if (thumbnail !== VIDEO_THUMBNAIL_FALLBACK) {
              setThumbnail(VIDEO_THUMBNAIL_FALLBACK);
            } else {
              setThumbnailFailed(true);
            }
          }}
        />
      ) : (
        <span
          className="absolute inset-0 bg-ink-900"
          aria-hidden="true"
        />
      )}

      <span className="absolute inset-0 bg-ink-900/45" aria-hidden="true" />

      <span className="absolute inset-0 flex items-center justify-center">
        <span className="flex h-16 w-16 items-center justify-center rounded-full border border-white bg-white">
          <Play
            className="ml-1 h-6 w-6 fill-ink-900 text-ink-900"
            strokeWidth={1}
            aria-hidden="true"
          />
        </span>
      </span>

      <span className="overline absolute bottom-4 left-5 text-slate-muted transition-transform duration-200 group-hover:translate-x-1">
        VIDEO · aCOMPUTER
      </span>
      <span className="overline absolute bottom-4 right-5 text-slate-muted">
        YouTube
      </span>
    </button>
  );
}
